(function () {
  function initStickyAtc() {
    var mainBtn = document.querySelector('[id^="ProductSubmitButton-"]');
    var stickyBar = document.getElementById('sticky-atc-bar');
    if (!mainBtn || !stickyBar) return;

    var stickyBtn = stickyBar.querySelector('.sticky-atc-bar__btn');
    var priceEl = stickyBar.querySelector('.sticky-atc-bar__price');

    // Show bar only when the main ATC button has scrolled above the viewport
    var intersectionObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('sticky-atc-bar--visible', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
      },
      { threshold: 0 }
    );
    intersectionObserver.observe(mainBtn);

    // Mirror disabled / sold-out state from main button
    function syncState() {
      var disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.disabled = disabled;
    }
    syncState();
    new MutationObserver(syncState).observe(mainBtn, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    // Sync price from the main price element when variant changes
    if (priceEl) {
      var priceContainer = document.querySelector(
        '.product__info-wrapper .price, .product__info-container .price'
      );
      if (priceContainer) {
        function updatePrice() {
          var salePrice = priceContainer.querySelector('.price-item--sale .money');
          var regularPrice = priceContainer.querySelector('.price-item--regular .money');
          var current = salePrice || regularPrice;
          if (current) priceEl.textContent = current.textContent.trim();
        }
        updatePrice();
        new MutationObserver(updatePrice).observe(priceContainer, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    }

    // Proxy click to the main ATC button so Dawn's form logic runs normally
    stickyBtn.addEventListener('click', function () {
      mainBtn.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
